const pageVariants = Object.freeze({
    ZENA: 'zenahr',
    NET: 'nethr',
    RTL: 'rtlhr',
    DANAS: 'danashr'
})
export default pageVariants
